import { gql } from '@apollo/client'

export const GET_RELATED_PRODUCTS = gql`
    query RelatedProducts ($id: ID!) {
        relatedProducts (id: $id) {
            id,
            name,
            version,
            slug,
            last_updated,
            is_popular,
            is_featured,
            is_active,
            is_cloud_product,
            cloud_starting_price_period,
            cloud_starting_price_net,
            is_free,
            rating_total,
            rating_count
            starting_price
            logo {
                url,
                width,
                height
            }
            compatibilities {
                software,
                version
            },
            descriptions {
                id,
                intro,
                description,
                language
            }
            categories {
                id,
                category
            }
            licenses {
                id,
                prices {
                    id,
                    price_net
                },
                names {
                    id, 
                    name,
                    language
                }
            }
            medias {
                id,
                ordering,
                filename,
                media {
                    url
                    height
                    width
                }
            }
            tags {
                id,
                tag
            },
            company {
                id,
                slug
            }
        }
    }
`
